var map = {
	"./AntDesign.ttf": 99018,
	"./Entypo.ttf": 65434,
	"./EvilIcons.ttf": 70935,
	"./Feather.ttf": 2626,
	"./FontAwesome.ttf": 39915,
	"./FontAwesome5_Brands.ttf": 1009,
	"./FontAwesome5_Regular.ttf": 54737,
	"./FontAwesome5_Solid.ttf": 88748,
	"./Fontisto.ttf": 58161,
	"./Foundation.ttf": 53686,
	"./Ionicons.ttf": 36245,
	"./MaterialCommunityIcons.ttf": 61197,
	"./MaterialIcons.ttf": 12744,
	"./Octicons.ttf": 51185,
	"./SimpleLineIcons.ttf": 71129,
	"./Zocial.ttf": 52251
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15241;